module.exports = __webpack_public_path__ + "img/pro_thirteen_12.53974a47.jpg";